import React from "react";
import "./ActivityPopup.css";
import ActivityCard from "./ActivityCard";

const EditCycle = ({ closeModal, closeIcon, data, handleActivity }) => {
  const hanldeButton = (index) => {
    handleActivity(index);
  };
  return (
    <>
      <div className="ac-title-close-icon-div">
        <p className="ac-title pb-2">Activity</p>
        <img
          src={closeIcon}
          alt=""
          onClick={closeModal}
          style={{ cursor: "pointer" }}
          id="closeIcon"
        />
      </div>
      <div className="ac-main-scroll">
        {data?.map((item, index) => (
          <ActivityCard
            key={index}
            data={item}
            index={index}
            onClickActivity={hanldeButton}
          />
        ))}
      </div>
    </>
  );
};

export default EditCycle;
